var _rect, _g, _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonationQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "QR code",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 80,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 40,
    height: 40,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 20,
    width: 80,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 40,
    width: 40,
    height: 40,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 200,
    width: 80,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 220,
    width: 40,
    height: 40,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 20,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 20,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 100,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 100,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 100,
    width: 40,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 140,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 140,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 180,
    width: 40,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 120,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 120,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 120,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 160,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 160,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 160,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 220,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 220,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 220,
    width: 20,
    height: 20
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 56,
    fill: "#fff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 166,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 74,
    textAnchor: "middle",
    fill: "#000",
    fontWeight: "bold"
  }, "\u092A\u0947")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonationQr);
export default __webpack_public_path__ + "static/media/donation-qr.68cbd2451b1ba0d635b49d247a0fb705.svg";
export { ForwardRef as ReactComponent };